export function createLookup<T extends Record<string, any>>(opts: {
  of: T[]
  by: keyof T
}): Record<string, T> {
  const objects = opts.of
  const idKey = opts.by
  return objects.reduce((acc, cur) => {
    acc[cur[idKey]] = cur
    return acc
  }, {} as Record<string, T>)
}

export function createListLookup<T extends Record<string, any>>(opts: { of: T[]; by: keyof T }) {
  const objects = opts.of
  const idKey = opts.by
  return objects.reduce((acc, cur) => {
    const lookupListExists = !!acc[cur[idKey]]
    if (lookupListExists) {
      acc[cur[idKey]].push(cur)
    } else {
      acc[cur[idKey]] = [cur]
    }
    return acc
  }, {} as Record<string, T[]>)
}

export function createGroupedLookup<T extends Record<string, any>>(props: {
  of: T[]
  groupIds: string[]
  matchingProperty: string
}): Record<string, T[]> {
  const objects = props.of
  const idKey = props.matchingProperty
  return props.groupIds.reduce((acc, cur) => {
    acc[cur] = objects.filter((child) => child[idKey] === cur)
    return acc
  }, {} as Record<string, T[]>)
}
